import { Cue } from "@modules/player";
import { PlayerSettings, Source, StepInfo } from "@types";

export function formatTime(timeInSeconds: number) {
  if (timeInSeconds) {
    const result = new Date(timeInSeconds * 1000)
      .toISOString()
      .substring(11, 19)
      .split(":");

    return {
      minutes: result[1] ?? "00",
      seconds: result[2] ?? "00",
      hours: result[0] ?? "00",
    };
  }
  return {
    minutes: "00",
    seconds: "00",
    hours: "00",
  };
}

export const formatTimeStringToSecond = (time: string) => {
  const [hour, minute, second] = time.split(":");

  return Number(hour) * 3600 + Number(minute) * 60 + Number(second);
};
export const DEFAULT_SETTINGS: PlayerSettings = {
  fullScreen: false,
  pip: false,
  quality: "720p",
  volume: 1,
  speedRate: 1,
  pipEnable: true,
  fullScreenEnable: true,
  pipSupported: true,
  lastVolume: 1,
  isMuted: false,
  withSubtitle: true,
  subtitleOn: true,
};

export const handleVideoSources = (data: {
  prev: Source[];
  theLesson: StepInfo;
  isVideoCourse: boolean;
  src_480?: string;
  src_720?: string;
}) => {
  const { isVideoCourse, prev, theLesson, src_480, src_720 } = data;
  if (isVideoCourse) {
    const result: Source[] = [];

    if (theLesson) {
      if (theLesson.online_link_480)
        result.push({ label: "480p", url: theLesson.online_link_480 });
      if (theLesson.online_link_720 || theLesson.online_link)
        result.push({
          label: "720p",
          url: theLesson.online_link_720 || theLesson.online_link,
        });
      if (theLesson.online_link_1080)
        result.push({ label: "1080p", url: theLesson.online_link_1080 });
    }
    return result;
  } else {
    const findIndexByLabel = (label: string, list: Source[]) =>
      list.findIndex((f) => f.label === label);
    const srcList = [];

    const idx720p = findIndexByLabel("720p", prev);
    const idx480p = findIndexByLabel("480p", prev);
    if (
      (!src_720 && idx720p < 0) ||
      (src_720 && idx720p >= 0 && prev[idx720p].url === src_720)
    ) {
      if (
        (!src_480 && idx480p < 0) ||
        (src_480 && idx480p >= 0 && prev[idx480p].url === src_480)
      ) {
        return prev;
      }
    }
    if (src_720)
      srcList.push({
        label: "720p",
        url: src_720,
      });
    if (src_480)
      srcList.push({
        label: "480p",
        url: src_480,
      });

    return srcList;
  }
};

export const parseVTT = (data: string) => {
  const lines = data.split("\n").map((line) => line.trim());
  const cues: Cue[] = [];

  for (let i = 0; i < lines.length; i++) {
    if (lines[i].includes("-->")) {
      const [start, end] = lines[i].split(" --> ");
      const text = lines[i + 1];
      cues.push({
        start: toSeconds(start),
        end: toSeconds(end),
        text: text || "",
      });
    }
  }

  return cues;
};

export const toSeconds = (time: string) => {
  const [sWithMs = "0", m = "0", h = "0"] = time.split(":").reverse();

  const [s = "0", ms = "0"] = sWithMs.split(".");

  return (
    Number(h) * 3600 + Number(m) * 60 + Number(s) + (Number(ms) || 0) / 1000
  );
};

export const hasCameFromInternalLink = () => {
  if (typeof document !== "undefined") {
    if (!document.referrer) {
      return false;
    } else {
      try {
        const refUrl = new URL(document.referrer);
        return refUrl.origin === window.location.origin;
      } catch {
        return false;
      }
    }
  }
};
